export const withVersion = (endpoint, config) => `${config.apiVersion}/${endpoint}`
